import { useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";

/**
 * @function ImportFilePreviewWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Preview widget for the ImportFileNewTemplatePage.
 */
export default function ImportFilePreviewWidget(props) {
    const { data } = useStateManager();
    const participants = data.achToParticipants.participants;

    const participantItems = participants.map(item => {
        const participant = item.participant;
        return <p key={participant.id}><span data-point={ `File_Preview_Row_Participant_Name_${ item.id }`}>{participant.participantName}</span>,<span>{participant.fullNumber}</span>,<span>{participant.routing}</span>,<span>1</span>,<span>{participant.transactionCode}</span></p>;
    })
    
    return (
        <div className="import-file-preview-widget">
            <h2>File Preview</h2>
            <p>Showing rows from beginning and end of file</p>
            <div className="file-preview-container ">
                {participantItems}
            </div>
        </div>
    )
}
